import { render, staticRenderFns } from "./InterventionRecordsForm.vue?vue&type=template&id=02635bf2&"
import script from "./InterventionRecordsForm.vue?vue&type=script&lang=js&"
export * from "./InterventionRecordsForm.vue?vue&type=script&lang=js&"
import style0 from "./InterventionRecordsForm.vue?vue&type=style&index=0&id=02635bf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports